import { render, staticRenderFns } from "./ListPartners.vue?vue&type=template&id=157442b7&scoped=true&"
import script from "./ListPartners.vue?vue&type=script&lang=js&"
export * from "./ListPartners.vue?vue&type=script&lang=js&"
import style0 from "./ListPartners.vue?vue&type=style&index=0&id=157442b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157442b7",
  null
  
)

export default component.exports